import { BeneFormPersonComponent } from './bene-form.person.component/bene-form.person.component';
import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnDestroy,
} from '@angular/core';

import { BeneFormPersonComponentCoverPath } from './bene-form.person.component/coverpath/bene-form.person.component.coverpath';
import { BeneFormChildrenComponentCoverPath } from './bene-form.children.component/coverpath/bene-form.children.component.coverpath';
import { BeneFormOtherTrustComponentCoverPath } from './bene-form.other-trust.component/coverpath/bene-form.other-trust.component.coverpath';
import { BeneFormEstateComponent } from './bene-form.estate.component/bene-form.estate.component';
import { BeneFormOtherTrustComponent } from './bene-form.other-trust.component/bene-form.other-trust.component';
import { BeneListService } from '../../services/beneList.service';

import { Beneficiary } from '../../interfaces/policy-admin-interfaces/beneficiary.interface';
import { PartyPerson } from '../../interfaces/policy-admin-interfaces/party-person.interface';
import { Party } from '../../interfaces/policy-admin-interfaces/party.interface';

import { Router, ActivatedRoute } from '@angular/router';
import { ModalRouteService } from '../../services/modal-route.service';
import { ModalService } from '../../services/modal.service';

import { FormGroup, FormBuilder } from '@angular/forms';

import _ from 'lodash';
import { BeneFormPersonComponentMMDirect } from './bene-form.person.component/mmdirect/bene-form.person.component.mmdirect';
import { BeneFormChildrenComponentMMDirect } from './bene-form.children.component/mmdirect/bene-form.children.component.mmdirect';
import { Product } from '../../../../../js/static/Product';

@Component({
  selector: 'bene-form',
  templateUrl: './bene-form.component.html',
  providers: [BeneListService],
})
export class BeneFormComponent implements OnDestroy {
  @ViewChild('target', { read: ViewContainerRef, static: true }) target: ViewContainerRef;
  private componentRef: ComponentRef<any>;
  private subComponentsCoverPath = {
    person: BeneFormPersonComponentCoverPath,
    children: BeneFormChildrenComponentCoverPath,
    estate: BeneFormEstateComponent,
    other: BeneFormOtherTrustComponentCoverPath,
    person2: BeneFormPersonComponentCoverPath,
    trust: BeneFormEstateComponent,
  };
  private subComponentsMMDirect = {
    person: BeneFormPersonComponentMMDirect,
    children: BeneFormChildrenComponentMMDirect,
    estate: BeneFormEstateComponent,
    other: BeneFormOtherTrustComponentCoverPath,
    person2: BeneFormPersonComponentCoverPath,
    trust: BeneFormEstateComponent,
  };
  private subComponents: object;
  beneForm: FormGroup;

  @Input() type: string;
  addOrEdit: string;
  componentSelected: boolean = false;
  beneType: string;
  beneTypeName: string;
  @Input() dismiss;
  headerClass: string;
  readonly headerText: string =
    'Although much of the contact information is optional, the more you can provide, the easier it will be to distribute the benefits of your claim.';

  public isDisabled: boolean = false;
  public beneTypes = [
    { value: 'person', description: "Insured's spouse, partner, or fiancé" },
    { value: 'children', description: "Insured's children" },
    { value: 'person2', description: 'Other named individual' },
    { value: 'estate', description: "Insured's estate" },
    { value: 'trust', description: "A trust under the insured's will" },
    { value: 'other', description: 'Other trust' },
  ];
  public widgetType: string;

  constructor(
    private compiler: ComponentFactoryResolver,
    private beneListService: BeneListService,
    private activatedRouter: ActivatedRoute,
    private modalRouteService: ModalRouteService,
    private router: Router,
    public modalService: ModalService,
    private fb: FormBuilder
  ) {
    this.widgetType = this.beneListService.getChannelName();

    if (
      Product.channels.MMOPM.name === this.widgetType ||
      Product.channels.MMTRAD.name === this.widgetType ||
      Product.channels.CAS.name === this.widgetType
    ) {
      this.subComponents = this.subComponentsCoverPath;
    } else if (Product.channels.MMDirect.name === this.widgetType) {
      this.subComponents = this.subComponentsMMDirect;
    }

    this.beneForm = this.fb.group({
      selectedType: ['', null],
    });
  }

  ngOnInit(): void {
    if (this.target !== undefined) {
      this.setup();
    }
  }

  ngOnDestroy(): void {
    this.beneForm.reset();
  }

  setup() {
    this.beneType = this.type;
    this.beneTypeName = this.beneType === 'Primary' ? 'primary' : 'alternate';
    this.headerClass = 'subtext';
    this.addOrEdit = 'Add';
    if (this.type === 'Edit') {
      const bene = this.beneListService.getCurrentBene();
      this.beneType = this.beneListService.getPrimaryOrContingent();
      this.beneTypeName = this.beneType === 'Primary' ? 'primary' : 'alternate';
      this.componentSelected = true;
      this.addOrEdit = 'Edit';
      let beneficiaryRelationship = bene.beneficiaryPartyType;
      let subComponent = 'person';
      if (
        bene.beneficiaryType === '11' ||
        bene.beneficiaryType === '11-1' ||
        bene.beneficiaryType === '11-2' ||
        bene.beneficiaryType === '12' ||
        bene.beneficiaryType === '12-1' ||
        bene.beneficiaryType === '12-2' ||
        bene.beneficiaryType === '13' ||
        bene.beneficiaryType === '13-1' ||
        bene.beneficiaryType === '13-2' ||
        bene.beneficiaryType === '14' ||
        bene.beneficiaryType === '14-1' ||
        bene.beneficiaryType === '14-2' ||
        bene.beneficiaryType === '15' ||
        bene.beneficiaryType === '15-1' ||
        bene.beneficiaryType === '15-2'
      ) {
        subComponent = 'children';
      }
      if (bene.beneficiaryType === '7') {
        beneficiaryRelationship = 'other';
        subComponent = 'other';
      }
      if (bene.beneficiaryType === '1' || bene.beneficiaryType === '1-1' || bene.beneficiaryType === '1-2') {
        beneficiaryRelationship = 'person2';
      }

      this.beneForm.controls['selectedType'].reset({ value: beneficiaryRelationship, disabled: true });
      this.isDisabled = true;

      const childComponent = this.subComponents[subComponent];
      const componentFactory = this.compiler.resolveComponentFactory(childComponent);
      this.target.clear();
      this.componentRef = this.target.createComponent(componentFactory);
    }
  }

  switchComponent(): void {
    this.componentSelected = true;

    let subComponent;

    switch (this.widgetType) {
      case Product.channels.CAS.name:
      case Product.channels.MMDirect.name:
      case Product.channels.MMTRAD.name:
      case Product.channels.MMOPM.name:
        subComponent = this.beneForm.get('selectedType').value;
        break;
      default:
        throw Error(`Unsupported widget type: ${this.widgetType}`);
    }

    let bene: Beneficiary;
    const d = new Date();
    const actionDate = d.getMonth() + 1 + '\\' + d.getDate() + '\\' + d.getFullYear();

    bene = {
      ratio: 0,
      action: 'created',
      actionDate: actionDate,
      beneficiaryType: '',
      partyInfo: {
        name: '',
      },
      id: null,
    };

    if (subComponent === 'person') {
      bene.beneficiaryType = '9-1';
      const temp: PartyPerson = {
        phone: {
          number: '',
        },
        name: '',
        person: {
          dob: '',
          govtId: '',
          govtIdType: 'ssn',
          firstName: '',
          middleName: '',
          lastName: '',
          residentialAddress: {
            street: '',
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip: '',
          },
        },
        relation: {
          description: '',
          govtId: '',
          govtIdType: 'ssn',
        },
      };
      bene.partyInfo = temp;
      bene.beneficiaryPartyType = 'person';
    } else if (subComponent === 'person2') {
      subComponent = 'person';

      bene.beneficiaryType = '1-1';
      const temp: PartyPerson = {
        phone: {
          number: '',
        },
        name: '',
        person: {
          dob: '',
          govtId: '',
          govtIdType: 'ssn',
          firstName: '',
          middleName: '',
          lastName: '',
          residentialAddress: {
            street: '',
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip: '',
          },
        },
        relation: {
          description: '',
          govtId: '',
          govtIdType: 'ssn',
        },
      };
      bene.partyInfo = temp;
      bene.beneficiaryPartyType = 'person';
    } else if (subComponent === 'trust') {
      subComponent = 'estate';

      bene.beneficiaryType = '6';
      bene.beneficiaryPartyType = 'trust';
    } else if (subComponent === 'other') {
      bene.beneficiaryType = '7';
      bene.beneficiaryPartyType = 'trust';
      const temp: Party = {
        name: '',
        phone: {
          number: '',
        },
        entity: {
          govtId: '',
          trust: true,
          formedDate: '',
          govtIdType: 'itin',
          legalAddress: {
            street: '',
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip: '',
          },
        },
      };
      bene.partyInfo = temp;
    } else if (subComponent === 'estate') {
      bene.beneficiaryType = '2';
      bene.beneficiaryPartyType = 'estate';
    } else if (subComponent === 'children') {
      bene.beneficiaryPartyType = 'children';
      bene.relatedParty = {
        partyInfo: {
          person: {
            firstName: '',
            middleName: '',
            lastName: '',
          },
        },
      };
    }

    this.beneListService.setCurrentBene(bene);
    this.beneListService.setPrimaryOrContingent(this.beneType);

    const childComponent = this.subComponents[subComponent];
    const componentFactory = this.compiler.resolveComponentFactory(childComponent);
    this.target.clear();
    this.componentRef = this.target.createComponent(componentFactory);
  }

  cancel(): void {
    this.modalRouteService.changeRoute('bene-list');
    this.beneForm.reset();
  }

  checkCancel(): void {
    this.modalService.showModal = true;
  }
}
